exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ms-Dialog-main.CjPPv1TJPNp0VrRASUKt_{min-width:400px}._2ViB4S4aZV9d4CiO2pObFU{width:100%}.BHGBnV8se8FmkT7_3x0Na{width:100%;min-width:250px;height:32px;color:var(--black)}html[dir] .BHGBnV8se8FmkT7_3x0Na{margin:5px 0;background-color:var(--white);border:1px solid var(--black);border-radius:2px}html[dir=ltr] .BHGBnV8se8FmkT7_3x0Na{padding:0 0 0 5px}html[dir=rtl] .BHGBnV8se8FmkT7_3x0Na{padding:0 5px 0 0}", ""]);
// Exports
exports.locals = {
	"numberingDialog": "CjPPv1TJPNp0VrRASUKt_",
	"numberingContent": "_2ViB4S4aZV9d4CiO2pObFU",
	"numberingInput": "BHGBnV8se8FmkT7_3x0Na"
};